import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // Validar email
      if (!email) {
        setError('Por favor ingrese su correo electrónico');
        setLoading(false);
        return;
      }
      
      // Enviar solicitud al servidor
      const response = await axios.post('/api/auth/forgot-password', { email });
      
      // Almacenar el email para la página de verificación
      localStorage.setItem('resetPasswordEmail', email);
      
      // Mostrar mensaje de éxito
      setSuccess(true);
      
      // Redirigir a la página de verificación después de 2 segundos
      setTimeout(() => {
        navigate('/verify-reset-code', { state: { email } });
      }, 2000);
      
    } catch (err) {
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('Error al procesar la solicitud. Por favor intente nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-form-container">
        <div className="auth-header">
          <h2>Recuperar Contraseña</h2>
          <p>Ingrese su correo electrónico para recibir un código de verificación</p>
        </div>
        
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i> {error}
          </div>
        )}
        
        {success && (
          <div className="success-message">
            <i className="fas fa-check-circle"></i> Se ha enviado un código de verificación a su correo electrónico. Redirigiendo...
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <div className="input-with-icon">
              <i className="fas fa-envelope input-icon"></i>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading || success}
                placeholder="Ingrese su correo electrónico"
                required
                onInvalid={(e) => e.target.setCustomValidity('Por favor ingrese un correo electrónico válido')}
                onInput={(e) => e.target.setCustomValidity('')}
                autoComplete="email"
              />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="btn-primary" 
            disabled={loading || success}
          >
            {loading ? (
              <>
                <span className="spinner"></span> Enviando...
              </>
            ) : (
              'Enviar Código'
            )}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>
            <Link to="/login">Volver al inicio de sesión</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
